const initialState = {
  data: [],
  loading: true,
  cache: {},
};

export const GetAllPurchasePay = (state = initialState, action) => {
  switch (action.type) {
    case "get_allpurchasepay":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "set_loading_purchasepay":
      return {
        ...state,
        loading: action.payload,
      };

    case "clear_purchasepay_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
